import { render, staticRenderFns } from "./EmailBody.vue?vue&type=template&id=a2682cac&"
import script from "./EmailBody.vue?vue&type=script&lang=js&"
export * from "./EmailBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports